export const yearDisplayFormat            = 'YYYY';

export const dateDisplayFormat            = 'DD.MM.YYYY';

export const dateParseFormat              = 'YYYY-MM-DD';

export const dateTimeDisplayFormat        = 'DD.MM.YYYY HH:mm';

export const dateTimeParseFormat          = 'YYYY-MM-DD HH:mm';

export const dateTimeSecondsDisplayFormat = 'DD.MM.YYYY HH:mm:ss';

export const dateLongDisplayFormat        = 'Do MMM. YYYY';
